import { SettingCard } from './SettingCard';

export default SettingCard;
